import VisionAppPdfRequestList from './VisionAppPdfRequestList';

export default {
  list: VisionAppPdfRequestList,
};
